import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { environment } from '@env/environment';

@Component({
  selector: 'splash-screen-title-row',
  templateUrl: './splash-screen-title-row.component.html',
  styleUrls: ['./splash-screen-title-row.component.scss']
})
export class SplashScreenTitleRowComponent implements OnInit {
  @Input() splashStyleResources: any[] = [];
  @Input() generalSettingResources: any[] = [];
  @Input() splashScreensResources: any[] = [];

  isPreviewOpen: boolean = false;
  previewImageUrl: string = '';

  constructor(private snackbar: MatSnackBar) {}

  ngOnInit(): void {}

  getImageUrl(value: string): string {
    if (!value) {
      return '/assets/images/image-not-found-150x150.png';
    }
    if (value.startsWith('data:') || value.startsWith('http://') || value.startsWith('https://')) {
      return value;
    }
    return environment.s3BucketUrl + value;
  }

  openPreview(url: string): void {
    if (!url || url === '/assets/images/image-not-found-150x150.png') return;
    this.previewImageUrl = url;
    this.isPreviewOpen = true;
  }

  closePreview(): void {
    this.isPreviewOpen = false;
    this.previewImageUrl = '';
  }

  getSplashImageResource(): any {
    // 1. Try splashScreenImage from splashStyleResources if populated
    let res = this.getSplashStyleResource('splashScreenImage');
    if (res && res.content && res.content.data && (res.content.data.value || (res.content.data.file && res.content.data.file.name))) {
      return res;
    }
    // 2. Try main splashScreen from splashScreensResources
    if (this.splashScreensResources && Array.isArray(this.splashScreensResources)) {
      let mainSplash = this.splashScreensResources.find(
        (item: any) => item && item.content && item.content.data && item.content.data.key === 'splashScreen'
      );
      if (mainSplash) return mainSplash;
    }
    // 3. Fallback to splashScreenImage resource
    return res;
  }

  getSplashStyleResource(key: string): any {
    if (!this.splashStyleResources || !Array.isArray(this.splashStyleResources)) {
      return null;
    }
    return this.splashStyleResources.find(
      (item: any) => item && item.content && item.content.data && item.content.data.key === key
    );
  }

  getGeneralSettingResource(key: string): any {
    if (!this.generalSettingResources || !Array.isArray(this.generalSettingResources)) {
      return null;
    }
    return this.generalSettingResources.find(
      (item: any) => item && item.content && item.content.data && item.content.data.key === key
    );
  }

  getLogoStateTooltip(resource: any): string {
    const val = String(resource && resource.content && resource.content.data ? resource.content.data.value || '1' : '1');
    switch (val) {
      case '2':
        return 'Logo Position: Above Title';
      case '3':
        return 'Logo Position: Full Screen';
      case '1':
      default:
        return 'Logo Position: Beside Title';
    }
  }

  getLogoStateThumbLeft(resource: any): string {
    const val = String(resource && resource.content && resource.content.data ? resource.content.data.value || '1' : '1');
    switch (val) {
      case '2':
        return '16px';
      case '3':
        return '30px';
      case '1':
      default:
        return '2px';
    }
  }

  cycleLogoState(resource: any): void {
    if (!resource || !resource.content || !resource.content.data) return;
    const currentVal = String(resource.content.data.value || '1');
    let nextVal = '1';
    if (currentVal === '1') nextVal = '2';
    else if (currentVal === '2') nextVal = '3';
    else if (currentVal === '3') nextVal = '1';

    resource.content.data.value = nextVal;
    resource.content.data.isUpdated = true;

    const tooltipText = this.getLogoStateTooltip(resource);
    this.snackbar.open(tooltipText, '', {
      duration: 1500,
      verticalPosition: 'top',
    });
  }

  onSplashImageFileSelected(event: any, resource: any): void {
    if (event && event.target && event.target.files && event.target.files.length !== 0) {
      const file = event.target.files[0];
      resource.content.data.file = file;
      resource.content.data.isUpdated = true;
      const reader = new FileReader();
      reader.onload = () => {
        resource.content.data.value = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
}
